// src/components/footerConfigs.js
import praLogo from "../assets/pra_logo.jpg";
export const footerConfigs = {
  "bheema": {
    trust: "Rajendra Suriji Jain Education Trust(R)",
    // Official School Name (Reports, Certificates, Website)
  brandName: "Sha Maganlal Chamnaji Jain School,Shahapur",
    // Short School Name (SMS)
    smsSchoolName: "SMC Jain School, Shahapur",
    // Domain only (optional)
    domain: "https://www.smcjainschoolshp.org",
    // Address
    address:
  "Yadagiri Road,SHAHAPUR-585223 Dist:Yadagiri",
    contact: "+91 9448043663 | smcjschool@gmail.com",
    logo: praLogo,
    // School-specific Google Map
    googleMap:
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15285.291319681377!2d76.8650937!3d16.7107364!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc85d1b7586d19f%3A0xe82d7bbe3aa2b1a0!2z4KS24KS-4KS5IOCkj-CkuC7gpI_gpK4u4KS44KWALuCknOCliOCkqCDgpLjgpY3gpJXgpYLgpLIg4KS24KS54KS-4KSq4KWC4KSw!5e0!3m2!1smr!2sin!4v1715501891010!5m2!1smr!2sin",
    socialLinks: {
      instagram: "https://www.instagram.com/explore/locations/167987497203193/smc-jain-higher-primary-school/",
      whatsapp:   "https://wa.me/yourwhatsapplink",
      youtube:    "https://www.youtube.com/channel/UCHjV39fsSfCTyOxVU63Q_sA/videos",
      facebook:   "https://www.facebook.com/smcjschool/",
      twitter:    "https://twitter.com"
    }
  },
  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }
  // add more customer configs here...
};
